import { ContentTwoxOneVisual } from "./styles";
import { VisualArticle } from "@/widgets/Nota/Templates/stylesModulesGenericVisual.js";
import ContentTitle from "@/shared/ContentTitle";
import ContentImage from "@/shared/ContentImage";
import { LinkAbsolute } from "@/shared/LinkAbsolute";
import VideoLoop from "@/shared/VideoLoop";
import { clickContent } from "@/shared/Analitics/GoogleAnalytics4";
import useNewsDataModules from "@/hooks/useNewsDataModules";
import MAM from "@/shared/MAM";
import Streaming from "@/shared/Streaming";

const TwoxOneVisual = (props) => {
  const {
    asPath,
    author = [],
    authorSignature,
    containerName,
    iconMultimedia,
    imagePreview,
    imageWeb,
    isPreview,
    payWallExclusive,
    section = [],
    subtitle,
    title,
    titleLocation,
    url,
    urlTarget,
    mams,
    videosOpenLoop,
    videoLoop,
    displayTitle,
    videoLoopFlavors = []
  } = useNewsDataModules(props, {
    desktop: ["rectangle_lg", "2_1_S2"],
    mobile: ["square_md", "1_1_S2"],
  });

  let streaming = Object.keys(props)?.filter((key) => /^streaming_/.test(key));
  if (streaming?.length > 0) {
    streaming = {
      link: props?.streaming_link,
      mute: props?.streaming_mute,
      autoplay: props?.streaming_autoplay,
    };
  } else {
    streaming = null;
  }

  return (
    <VisualArticle
      suppressHydrationWarning
      className={`${
        !streaming ? "visual-article-nota" : "visual-article-streaming-twoxone"
      }`}
    >
      <ContentTwoxOneVisual
        mamsEnabled={mams?.enabled}
        className={`modulo2x1 visual ${
          videosOpenLoop?.enabled ? "videoLoopBox" : ""
        }`}
      >
        <ContentTitle
          author={author}
          authorSignature={authorSignature}
          title={displayTitle}
          subtitle={subtitle}
          section={section}
          payWallExclusive={payWallExclusive}
          titleLocation={titleLocation}
        />
        {videosOpenLoop?.enabled ? (
          <VideoLoop
            titleLocation={titleLocation}
            videoLoop={videoLoop}
            posterPlayer={true}
            width={"640"}
            videoLoopFlavors={videoLoopFlavors}
          />
        ) : !streaming ? (
          <picture className={titleLocation}>
            {mams?.enabled && (
              <MAM
                sport={mams.deporte}
                match={mams.idPartido}
                type="home"
                isPreview={isPreview}
              />
            )}
            {isPreview ? (
              imagePreview && (
                <ContentImage
                  iconMultimedia={iconMultimedia}
                  data={imagePreview}
                  alt={title}
                />
              )
            ) : (
              <ContentImage
                iconMultimedia={iconMultimedia}
                data={imageWeb}
                alt={title}
              />
            )}
          </picture>
        ) : (
          <Streaming {...streaming} />
        )}
        <LinkAbsolute
          suppressHydrationWarning
          href={url}
          target={urlTarget}
          aria-label={title}
          onClick={() =>
            clickContent(
              { contentType: title, contentList: containerName },
              url,
              asPath
            )
          }
        />
      </ContentTwoxOneVisual>
    </VisualArticle>
  );
};

export default TwoxOneVisual;
